export default {
  contacts: 'contacts',
  view: 'view',
  contactus: 'contactus'
}
